/* eslint-disable perfectionist/sort-objects */
export const URL = {
  LOGIN: 'v1/auth/login',
  LOGIN_GUEST: 'v1/auth/login/guest',
  SIGNUP: 'v1/auth/signup',
  REFRESH: 'v1/auth/refresh',
  LOGOUT: 'v1/auth/logout',
  MFA_ENROLL: 'v1/auth/mfa-enroll',
  MFA_VERIFY: 'v1/auth/mfa-verify',
  MFA_CHALLENGE: 'v1/auth/mfa-challenge',
  SEND_EMAIL_VERIFICATION: 'v1/auth/send-email-verification',
  CHECK_EMAIL_VERIFICATION: 'v1/auth/check-email-verification',
  FORGOT_PASSWORD: 'v1/auth/forgot-password',
  SSO_START: 'v1/auth/sso/start',
  SSO_START_BY_CONNECTION: 'v1/auth/sso/start-by-connection',
  SSO_CALLBACK: 'v1/auth/sso/callback',
  PROFILE_DETAILS: '/v1/auth/profile',
  PROFILE_FORM: '/v1/auth/profile-form',
  PROFILE_FORM_SUBMIT: '/v1/auth/profile-form/:id',

  COURSE_DETAILS: 'v1/courses/active',

  COURSE_STEPS_LIST: 'v1/course-steps',
  COURSE_STEP_DETAILS: 'v1/course-steps/:id',

  RESOURCES_LIST: 'v1/resources',
  RESOURCES_DETAILS: 'v1/resources/:id',

  COURSE_SUBMISSIONS: 'v1/course-submissions',
  COURSE_SUBMISSIONS_LAST: 'v1/course-submissions/last',
  COURSE_SUBMISSIONS_RESET: 'v1/course-submissions/reset',
  COURSE_SUBMISSIONS_CERTIFICATE_PDF:
    'v1/course-submissions/:id/certificate-pdf',

  COURSE_STEP_SUBMISSIONS_LIST: 'v1/course-step-submissions',
  COURSE_STEP_SUBMISSIONS_CURRENT:
    'v1/course-step-submissions/current-submission/:id',
  COURSE_STEP_SUBMISSIONS_FORM:
    'v1/course-step-submissions/current-submission/form/:id',
  COURSE_STEP_SUBMISSIONS_RESOURCE:
    'v1/course-step-submissions/current-submission/resource/:id',

  COURSE_ENROLLMENTS: 'v1/course-enrollments',
  COURSE_ENROLLMENTS_BY_COURSE_ID: 'v1/course-enrollments/:id',

  RESOLVE_TENANT: 'v1/tenants/resolve',

  CONTACT_US_PUBLIC: 'v1/contact-us/public',
};
